<p-dialog
  [(visible)]="visible"
  class="additional-internal-request"
  (onHide)="closeDialog()"
  [style]="{ width: '650px', height: '600px' }"
  header="Internal Request"
>
  <div class="d-flex flex-wrap h-100 d-flex-column">
    <div class="flex-grow-1" style="background-color: #f8f8f8; padding: 15px; margin-top: 15px">
      <div class="loadingMessage text-center p-3" *ngIf="isLoading">
        <i class="fa fa-2x fa-spin fa-spinner"></i>
      </div>

      <div class="d-flex h-100 d-flex-column" *ngIf="!isLoading">
        <div class="flex-shrink-1">
          <div class="d-flex flex-wrap d-flex-row w-100 grid-gap-10">
            <div class="flex-grow-1">
              <div class="pb-2">Choose the user to raise an incident against:</div>
              <p-dropdown
                (onChange)="setReassignUser($event)"
                [options]="assigneesOptions"
                appendTo="body"
                placeholder="Not Assigned"
                [filter]="true"
              ></p-dropdown>
            </div>
          </div>
        </div>

        <div class="mt-10 flex-shrink-1">
          <div class="pb-2">Comment</div>
        </div>
        <div class="flex-grow-1">
          <textarea
            class="comment"
            pInputTextarea
            [(ngModel)]="comment"
            style="width: 100%; height: 100%; padding: 10px"
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button pButton label="Cancel" (click)="closeDialog()" class="ui-button-tertiary"></button>
      <button
        pButton
        [disabled]="isSending"
        [label]="isSending ? 'Wait' : 'Send'"
        (click)="raiseAnIncident()"
        class="ui-button-primary"
      ></button>
    </div>
  </p-footer>
</p-dialog>
